import { lazy } from 'react';
import { importWithChunkRetry } from '../error/chunkLoadRecovery';

/**
 * React.lazy that retries a missing async chunk once, then reloads the tab
 * at most once (see chunkLoadRecovery.js). Use this for every route / dock
 * lazy() — raw React.lazy() turns a 404'd JS file into a full-app crash.
 */
export function lazyWithRetry(importer) {
  return lazy(() => importWithChunkRetry(importer));
}
